import {
  checkHttpStatus,
  dataUriToBlob,
  getApiBaseUrlWithOrg,
  getApiHeadersFromToken
} from '../../../utils'

export const fetchLevelActivities = async (apiData, levelId) => {
  const url = `${getApiBaseUrlWithOrg(
    apiData.orgId
  )}/mentor/levels/${levelId}/activity_quests`
  try {
    const response = checkHttpStatus(
      await fetch(url, {
        method: 'GET',
        headers: getApiHeadersFromToken(apiData.token)
      })
    )
    const data = await response.json()
    return data
  } catch (error) {
    console.log(error)
  }
}

export const createNewLevelActivity = async (
  apiData,
  levelId,
  activityName
) => {
  const url = `${getApiBaseUrlWithOrg(
    apiData.orgId
  )}/mentor/levels/${levelId}/activity_quests`
  const data = {
    activity_quest: { name: activityName }
  }

  try {
    const response = checkHttpStatus(
      await fetch(url, {
        method: 'POST',
        headers: getApiHeadersFromToken(apiData.token),
        body: JSON.stringify(data)
      })
    )

    return await response.json()
  } catch (error) {
    console.log(error)
  }
}

export const deleteLevelActivity = async (
  apiData,
  levelId,
  activityQuestId
) => {
  const url = `${getApiBaseUrlWithOrg(
    apiData.orgId
  )}/mentor/levels/${levelId}/activity_quests/${activityQuestId}`

  try {
    const response = checkHttpStatus(
      await fetch(url, {
        method: 'DELETE',
        headers: getApiHeadersFromToken(apiData.token)
      })
    )

    return await response
  } catch (error) {
    console.log(error)
  }
}

export const editLevelActivity = async (apiData, levelId, activity) => {
  const url = `${getApiBaseUrlWithOrg(
    apiData.orgId
  )}/mentor/levels/${levelId}/activity_quests/${activity.id}`

  try {
    const response = checkHttpStatus(
      await fetch(url, {
        method: 'PATCH',
        headers: getApiHeadersFromToken(apiData.token),
        body: JSON.stringify({
          activity_quest: {
            name: activity.name,
            description: activity.description,
            driving_question: activity.driving_question,
            goals: activity.goals,
            mentor_notes: activity.mentor_notes,
            mentor_assessment_questions: activity.mentor_assessment_questions,
            artifact_description: activity.artifact_description,
            artifact_type_id: activity.artifact_type_id,
            checkpoint: activity.checkpoint,
            work_product: activity.work_product
          }
        })
      })
    )
    return await response.json()
  } catch (error) {
    console.log(error)
  }
}

export const fetchSingleActivity = async (
  apiData,
  levelId,
  activityQuestId
) => {
  const url = `${getApiBaseUrlWithOrg(
    apiData.orgId
  )}/mentor/levels/${levelId}/activity_quests/${activityQuestId}`
  try {
    const response = checkHttpStatus(
      await fetch(url, {
        method: 'GET',
        headers: getApiHeadersFromToken(apiData.token)
      })
    )
    const data = await response.json()
    return data
  } catch (error) {
    console.log(error)
  }
}

export const fetchActivityMentorFiles = async (
  apiData,
  levelId,
  activityQuestId
) => {
  const url = `${getApiBaseUrlWithOrg(
    apiData.orgId
  )}/mentor/levels/${levelId}/activity_quests/${activityQuestId}/mentor_files`
  try {
    const response = checkHttpStatus(
      await fetch(url, {
        method: 'GET',
        headers: getApiHeadersFromToken(apiData.token)
      })
    )
    const data = await response.json()
    return data
  } catch (error) {
    console.log(error)
  }
}

export const moveActivityToDifferentLevel = async (
  apiData,
  levelId,
  activityQuestId,
  newLevelId
) => {
  const url = `${getApiBaseUrlWithOrg(
    apiData.orgId
  )}/mentor/levels/${levelId}/activity_quests/${activityQuestId}/change_level`
  try {
    const response = checkHttpStatus(
      await fetch(url, {
        method: 'PATCH',
        headers: getApiHeadersFromToken(apiData.token),
        body: JSON.stringify({
          activity_quest: {
            new_level_id: newLevelId
          }
        })
      })
    )
    return await response.json()
  } catch (error) {
    console.log(error)
  }
}

export const reorderActivities = async (
  apiData,
  levelId,
  activityQuestId,
  sortOrderPosition
) => {
  const url = `${getApiBaseUrlWithOrg(
    apiData.orgId
  )}/mentor/levels/${levelId}/activity_quests/${activityQuestId}/update_position`

  try {
    const response = checkHttpStatus(
      await fetch(url, {
        method: 'PATCH',
        headers: getApiHeadersFromToken(apiData.token),
        body: JSON.stringify({
          activity_quest: {
            sort_order_position: sortOrderPosition
          }
        })
      })
    )

    return await response.json()
  } catch (err) {
    console.log('ERROR', err)
  }
}

export const uploadImage = async (
  apiData,
  levelId,
  activityQuestId,
  type,
  dataUri,
  fileName
) => {
  const url = `${getApiBaseUrlWithOrg(
    apiData.orgId
  )}/mentor/levels/${levelId}/activity_quests/${activityQuestId}/update_icon_image`
  let data = new FormData()
  data.append(
    'activity_quest[' + type + '_image]',
    dataUriToBlob(dataUri),
    fileName
  )

  try {
    const response = checkHttpStatus(
      await fetch(url, {
        method: 'PATCH',
        headers: {
          Authorization: `Token token="${apiData.token}"`,
          Accept: 'application/vnd.oefngl.v3'
        },
        body: data
      })
    )
    return await response.json()
  } catch (error) {
    console.log(error)
  }
}

export const removeActivityIcon = async (apiData, levelId, activityQuestId) => {
  const url = `${getApiBaseUrlWithOrg(
    apiData.orgId
  )}/mentor/levels/${levelId}/activity_quests/${activityQuestId}/update_icon_image`

  try {
    const response = checkHttpStatus(
      await fetch(url, {
        method: 'PATCH',
        headers: getApiHeadersFromToken(apiData.token),
        body: JSON.stringify({
          activity_quest: {
            remove_icon_image: true
          }
        })
      })
    )

    return await response.json()
  } catch (err) {
    console.log('ERROR', err)
  }
}

export const fetchMentorFiles = async (apiData, levelId, activityQuestId) => {
  const url = `${getApiBaseUrlWithOrg(
    apiData.orgId
  )}/mentor/levels/${levelId}/activity_quests/${activityQuestId}/mentor_files`
  try {
    const response = checkHttpStatus(
      await fetch(url, {
        method: 'GET',
        headers: getApiHeadersFromToken(apiData.token)
      })
    )
    const data = await response.json()
    return data
  } catch (error) {
    console.log(error)
  }
}

export const uploadMentorFile = async (
  apiData,
  levelId,
  activityQuestId,
  file,
  description
) => {
  const url = `${getApiBaseUrlWithOrg(
    apiData.orgId
  )}/mentor/levels/${levelId}/activity_quests/${activityQuestId}/mentor_files`
  let data = new FormData()
  data.append('mentor_file[description]', description || '')
  data.append('mentor_file[attachment]', file)
  try {
    const response = checkHttpStatus(
      await fetch(url, {
        method: 'POST',
        headers: {
          Authorization: `Token token="${apiData.token}"`,
          Accept: 'application/vnd.oefngl.v3'
        },
        body: data
      })
    )
    return await response.json()
  } catch (error) {
    console.log(error)
  }
}

export const editMentorFile = async (
  apiData,
  levelId,
  activityQuestId,
  description,
  id
) => {
  const url = `${getApiBaseUrlWithOrg(
    apiData.orgId
  )}/mentor/levels/${levelId}/activity_quests/${activityQuestId}/mentor_files/${id}`

  try {
    const response = checkHttpStatus(
      await fetch(url, {
        method: 'PATCH',
        headers: getApiHeadersFromToken(apiData.token),
        body: JSON.stringify({
          mentor_file: { description: description }
        })
      })
    )
    return await response.json()
  } catch (error) {
    console.log(error)
  }
}

export const reorderMentorFile = async (
  apiData,
  levelId,
  activityQuestId,
  id,
  index
) => {
  const url = `${getApiBaseUrlWithOrg(
    apiData.orgId
  )}/mentor/levels/${levelId}/activity_quests/${activityQuestId}/mentor_files/${id}`

  try {
    const response = checkHttpStatus(
      await fetch(url, {
        method: 'PATCH',
        headers: getApiHeadersFromToken(apiData.token),
        body: JSON.stringify({
          mentor_file: { sort_order_position: index }
        })
      })
    )
    return await response.json()
  } catch (error) {
    console.log(error)
  }
}

export const deleteMentorFile = async (
  apiData,
  levelId,
  activityQuestId,
  mentorFileId
) => {
  const url = `${getApiBaseUrlWithOrg(
    apiData.orgId
  )}/mentor/levels/${levelId}/activity_quests/${activityQuestId}/mentor_files/${mentorFileId}`

  try {
    const response = checkHttpStatus(
      await fetch(url, {
        method: 'DELETE',
        headers: getApiHeadersFromToken(apiData.token)
      })
    )

    return await response.json()
  } catch (err) {
    console.log('ERROR', err)
  }
}

export const fetchResources = async (apiData, levelId, activityQuestId) => {
  const url = `${getApiBaseUrlWithOrg(
    apiData.orgId
  )}/mentor/levels/${levelId}/activity_quests/${activityQuestId}/resources`
  try {
    const response = checkHttpStatus(
      await fetch(url, {
        method: 'GET',
        headers: getApiHeadersFromToken(apiData.token)
      })
    )
    const data = await response.json()
    return data
  } catch (error) {
    console.log(error)
  }
}

export const fetchResource = async (
  apiData,
  levelId,
  activityQuestId,
  resourceId
) => {
  const url = `${getApiBaseUrlWithOrg(
    apiData.orgId
  )}/mentor/levels/${levelId}/activity_quests/${activityQuestId}/resources/${resourceId}`
  try {
    const response = checkHttpStatus(
      await fetch(url, {
        method: 'GET',
        headers: getApiHeadersFromToken(apiData.token)
      })
    )
    const data = await response.json()
    return data
  } catch (error) {
    console.log(error)
  }
}

export const createResource = async (
  apiData,
  levelId,
  activityQuestId,
  resourceName
) => {
  const url = `${getApiBaseUrlWithOrg(
    apiData.orgId
  )}/mentor/levels/${levelId}/activity_quests/${activityQuestId}/resources`
  const data = {
    resource: { name: resourceName }
  }

  try {
    const response = checkHttpStatus(
      await fetch(url, {
        method: 'POST',
        headers: getApiHeadersFromToken(apiData.token),
        body: JSON.stringify(data)
      })
    )

    return await response.json()
  } catch (error) {
    console.log(error)
  }
}

export const updateResource = async (
  apiData,
  levelId,
  activityQuestId,
  resourceId,
  resource
) => {
  const url = `${getApiBaseUrlWithOrg(
    apiData.orgId
  )}/mentor/levels/${levelId}/activity_quests/${activityQuestId}/resources/${resourceId}`
  const data = {
    resource: resource
  }
  try {
    const response = checkHttpStatus(
      await fetch(url, {
        method: 'PATCH',
        headers: getApiHeadersFromToken(apiData.token),
        body: JSON.stringify(data)
      })
    )
    return await response.json()
  } catch (error) {
    console.log(error)
  }
}

export const reorderResources = async (
  apiData,
  levelId,
  activityQuestId,
  resourceId,
  index
) => {
  const url = `${getApiBaseUrlWithOrg(
    apiData.orgId
  )}/mentor/levels/${levelId}/activity_quests/${activityQuestId}/resources/${resourceId}`
  const data = {
    resource: {
      sort_order_position: index
    }
  }
  try {
    const response = checkHttpStatus(
      await fetch(url, {
        method: 'PATCH',
        headers: getApiHeadersFromToken(apiData.token),
        body: JSON.stringify(data)
      })
    )
    return await response.json()
  } catch (error) {
    console.log(error)
  }
}

export const clearResourceFile = async (
  apiData,
  levelId,
  activityQuestId,
  resourceId
) => {
  const url = `${getApiBaseUrlWithOrg(
    apiData.orgId
  )}/mentor/levels/${levelId}/activity_quests/${activityQuestId}/resources/${resourceId}`
  const data = {
    resource: {
      clear_resource_file: true
    }
  }
  try {
    const response = checkHttpStatus(
      await fetch(url, {
        method: 'PATCH',
        headers: getApiHeadersFromToken(apiData.token),
        body: JSON.stringify(data)
      })
    )
    return await response.json()
  } catch (error) {
    console.log(error)
  }
}

export const fileUploadToResource = async (
  apiData,
  levelId,
  activityQuestId,
  resourceId,
  resource
) => {
  const url = `${getApiBaseUrlWithOrg(
    apiData.orgId
  )}/mentor/levels/${levelId}/activity_quests/${activityQuestId}/resources/${resourceId}/file`
  const data = {
    resource: resource
  }
  try {
    const response = checkHttpStatus(
      await fetch(url, {
        method: 'PATCH',
        headers: getApiHeadersFromToken(apiData.token),
        body: JSON.stringify(data)
      })
    )
    return await response.json()
  } catch (error) {
    console.log(error)
  }
}

export const deleteNewResource = async (
  apiData,
  levelId,
  activityQuestId,
  resourceId
) => {
  const url = `${getApiBaseUrlWithOrg(
    apiData.orgId
  )}/mentor/levels/${levelId}/activity_quests/${activityQuestId}/resources/${resourceId}`

  try {
    const response = checkHttpStatus(
      await fetch(url, {
        method: 'DELETE',
        headers: getApiHeadersFromToken(apiData.token),
        body: JSON.stringify({
          resource: { new_resource: true }
        })
      })
    )

    return await response
  } catch (err) {
    console.log('ERROR', err)
  }
}

export const deleteExistingResource = async (
  apiData,
  levelId,
  activityQuestId,
  resourcesId
) => {
  const url = `${getApiBaseUrlWithOrg(
    apiData.orgId
  )}/mentor/levels/${levelId}/activity_quests/${activityQuestId}/resources/${resourcesId}`

  try {
    const response = checkHttpStatus(
      await fetch(url, {
        method: 'DELETE',
        headers: getApiHeadersFromToken(apiData.token)
      })
    )

    return await response.json()
  } catch (err) {
    console.log('ERROR', err)
  }
}

export const fetchLinkedSkills = async (apiData, levelId, activityQuestId) => {
  const url = `${getApiBaseUrlWithOrg(
    apiData.orgId
  )}/mentor/levels/${levelId}/activity_quests/${activityQuestId}/framework_skills`
  try {
    const response = checkHttpStatus(
      await fetch(url, {
        method: 'GET',
        headers: getApiHeadersFromToken(apiData.token)
      })
    )
    const data = await response.json()
    return data
  } catch (error) {
    console.log(error)
  }
}

export const addLinkedSkill = async (
  apiData,
  levelId,
  activityQuestId,
  frameworkSkillId
) => {
  const url = `${getApiBaseUrlWithOrg(
    apiData.orgId
  )}/mentor/levels/${levelId}/activity_quests/${activityQuestId}/framework_skills`
  const data = {
    quest_framework_skill: {
      framework_skill_id: frameworkSkillId
    }
  }
  try {
    const response = checkHttpStatus(
      await fetch(url, {
        method: 'POST',
        headers: getApiHeadersFromToken(apiData.token),
        body: JSON.stringify(data)
      })
    )
    await response
    return
  } catch (error) {
    console.log(error)
  }
}

export const deleteLinkedSkill = async (
  apiData,
  levelId,
  activityQuestId,
  frameworkSkillId
) => {
  const url = `${getApiBaseUrlWithOrg(
    apiData.orgId
  )}/mentor/levels/${
    levelId
  }/activity_quests/${
    activityQuestId
  }/framework_skills/${
    frameworkSkillId
  }`
  try {
    const response = checkHttpStatus(
      await fetch(url, {
        method: 'DELETE',
        headers: getApiHeadersFromToken(apiData.token)
      })
    )
    await response
    return
  } catch (error) {
    console.log(error)
  }
}



// WEBPACK FOOTER //
// ./src/components/mycourses/Activities/API.js